module.exports = __webpack_public_path__ + "img/grandsmaanddaugther.a56fd063.png";